import { Link } from 'react-router-dom';
import { isNativeApp } from '../lib/platform';
import { openExternalUrl } from '../lib/openExternalUrl';

const TERMS_URL = 'https://peakperformanceiq.com/terms';
const PRIVACY_URL = 'https://peakperformanceiq.com/privacy';

const linkClass = 'text-sky-400 underline-offset-2 hover:underline';

/**
 * App Store Guideline 3.1.2 requires functional Terms of Use (EULA) and Privacy Policy
 * links on subscription / paywall UI.
 */
export function SubscriptionLegalLinks({ className = '' }: { className?: string }) {
  async function openLegal(url: string) {
    await openExternalUrl(url);
  }

  // Native: open production URLs in SFSafariView so reviewers get a clear external page.
  // Web: in-app routes so local/dev still works without a deploy.
  if (isNativeApp()) {
    return (
      <p className={`text-center text-[11px] leading-relaxed text-zinc-500 ${className}`}>
        <button type="button" className={linkClass} onClick={() => void openLegal(TERMS_URL)}>
          Terms of Use
        </button>
        <span className="mx-1.5 text-zinc-600">·</span>
        <button type="button" className={linkClass} onClick={() => void openLegal(PRIVACY_URL)}>
          Privacy Policy
        </button>
      </p>
    );
  }

  return (
    <p className={`text-center text-[11px] leading-relaxed text-zinc-500 ${className}`}>
      <Link to="/terms" className={linkClass}>
        Terms of Use
      </Link>
      <span className="mx-1.5 text-zinc-600">·</span>
      <Link to="/privacy" className={linkClass}>
        Privacy Policy
      </Link>
    </p>
  );
}
